import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavController } from '@ionic/angular';
import { StorageService } from 'src/app/core/services/storage/storage.service';
import { SettingsQuery } from 'src/app/shared/state/settings/settings.query';
import OneSignal from 'onesignal-cordova-plugin';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.css'],
})
export class LogoutComponent implements OnInit {
    params$;
    systemKeyParam;
    clinicIdParam;
    constructor(
        protected activatedRoute: ActivatedRoute,
        private navCtrl: NavController,
        private settingsQuery: SettingsQuery,
        private storage: StorageService
    ) {}

    ngOnInit(): void {
        this.params$ = this.activatedRoute.params.subscribe((params) => {
            this.systemKeyParam = params.systemKey;
            /** Parámetro de clinicId */
            if (params.clinicId) {
                this.clinicIdParam = params.clinicId;
            }
        });

        this.logout(this.systemKeyParam, this.clinicIdParam);
    }

    async logout(systemKey, clinicId) {
        if (!clinicId) {
            /** Si nos pasas solo el SK, borramos todos los registros asociados a esta SK */
            this.storage.remove('tokens-' + systemKey);

            const keysStorage = await this.storage.keys();
            keysStorage?.forEach((key) => {
                if (key.includes('tokens-' + systemKey)) {
                    this.storage.remove(key);
                }
            });
        } else {
            /** Si nos pasan el SK y la clínic ID, borramos además si hubiese solo con el SK */
            this.storage.remove('tokens-' + systemKey + '-' + clinicId);
            this.storage.remove('tokens-' + systemKey);
        }
        this.storage.remove('companyActive');
        OneSignal.logout();
        await this.storage.set('idDevice', '');
        this.goHome(systemKey);
    }

    goHome(systemKey) {
        this.navCtrl.navigateBack(
            '/' + (!this.settingsQuery.isGeneric() ? systemKey : '')
        );
    }
}
